var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-dialog.ts
import "@adornis/chemistry/elements/components/x-button";
import "@adornis/chemistry/elements/components/x-loader";
import { xComponents } from "@adornis/chemistry/elements/x-components";
import "@adornis/chemistry/renderable";
import { html, nothing } from "lit";
import { customElement } from "lit/decorators.js";
import { ref } from "lit/directives/ref.js";
import { ElementsPlainDialog } from "./x-plain-dialog";
import "@adornis/chemistry/elements/components/x-flex";
var ElementsDialog = class extends ElementsPlainDialog {
  static get element_name() {
    if (this === ElementsDialog)
      return "x-dialog";
    throw new Error("You need to define the element_name getter in order to make x-dialog work properly: " + this.name);
  }
  getInnerWrapper(options) {
    const wrapperElem = super.getInnerWrapper(options);
    wrapperElem.style.setProperty("background", this.colors.white);
    if (!options.draggable)
      wrapperElem.style.setProperty("border-radius", this.sizes.borderRadius);
    else {
      wrapperElem.style.setProperty("border-top-left-radius", this.sizes.borderRadius);
      wrapperElem.style.setProperty("border-top-right-radius", this.sizes.borderRadius);
    }
    wrapperElem.style.setProperty("max-width", "60vmax");
    return wrapperElem;
  }
  getContentWrapper(options) {
    const wrapperElem = super.getContentWrapper(options);
    if (!options.draggable)
      wrapperElem.style.removeProperty("height");
    return wrapperElem;
  }
  static confirm(text, {
    highlightDecline = false,
    acceptText = "Ja",
    declineText = "Nein"
  } = {}) {
    return this.showPopup({
      modal: true,
      closeOnEscape: true,
      content: (r) => {
        const enterListener = (e) => {
          if (e.key === "Enter")
            resolve(true);
        };
        document.addEventListener("keydown", enterListener);
        const resolve = (v) => {
          document.removeEventListener("keydown", enterListener);
          r(v);
        };
        return xComponents(html`
          <x-flex space="md" padding="md">
            <x-text>${text}</x-text>
            <x-flex horizontal end space="md">
              <x-button mode="${highlightDecline ? "action" : "outline"}" @click="${() => resolve(false)}">
                <x-text> ${declineText} </x-text>
              </x-button>
              <x-button mode="${highlightDecline ? "outline" : "action"}" @click="${() => resolve(true)}">
                <x-text> ${acceptText} </x-text>
              </x-button>
            </x-flex>
          </x-flex>
        `);
      }
    }).catch(() => false);
  }
  static alert(text, buttonText = "Ok") {
    return this.showPopup({
      closeOnEscape: true,
      content: (r) => {
        const enterListener = (e) => {
          if (e.key === "Enter")
            resolve();
        };
        document.addEventListener("keydown", enterListener);
        const resolve = () => {
          document.removeEventListener("keydown", enterListener);
          r();
        };
        return xComponents(html`
          <x-flex space="md" padding="md">
            ${typeof text === "string" ? html`<x-text> ${text} </x-text>` : text}
            <x-flex horizontal end space="md">
              <x-button @click="${() => resolve()}"> ${buttonText} </x-button>
            </x-flex>
          </x-flex>
        `);
      }
    }).catch(() => {
    });
  }
  static prompt(text, { placeholder = "", buttonText = "Ok" } = {}) {
    return this.showPopup({
      closeOnEscape: true,
      content: (r, reject) => {
        let response = "";
        const enterListener = (e) => {
          if (e.key === "Enter")
            resolve(response);
        };
        document.addEventListener("keydown", enterListener);
        const resolve = (v) => {
          document.removeEventListener("keydown", enterListener);
          r(v);
        };
        return xComponents(html`
          <x-flex space="md" padding="md">
            <x-text>${text}</x-text>
            <x-input
              ${ref((e) => requestAnimationFrame(() => e?.focus()))}
              placeholder-mode="hide"
              placeholder=${placeholder ?? ""}
              @value-changed=${(e) => response = e.detail.value}
            ></x-input>
            <x-flex horizontal end space="md">
              <x-button @click=${() => resolve(response)}> <x-text> ${buttonText} </x-text> </x-button>
            </x-flex>
          </x-flex>
        `);
      }
    });
  }
  static waitFor(promise, text, options = {}) {
    return this.showPopup({
      ...options,
      modal: true,
      content: (resolve, reject, dialog) => {
        promise.then((val) => resolve(val)).catch((error) => reject(error));
        return xComponents(html`
          <x-flex padding="xxl" space="lg" crossaxis-center center>
            <x-loader></x-loader>
            ${text ? html` <x-text> ${text} </x-text> ` : nothing}
          </x-flex>
        `);
      }
    });
  }
  static wait(text, options = {}) {
    let resolveReturn;
    this.showPopup({
      ...options,
      modal: true,
      content: (resolve, reject, dialog) => {
        resolveReturn = resolve;
        return xComponents(html`
          <x-flex padding="xxl" space="lg" crossaxis-center center>
            <x-loader></x-loader>
            ${text ? html` <x-text> ${text} </x-text> ` : nothing}
          </x-flex>
        `);
      }
    });
    return resolveReturn;
  }
  static success(text, buttonText = "Ok") {
    return this.showPopup({
      content: (resolve) => {
        return xComponents(html`
          <x-flex space="md" padding="md">
            <x-text>${text}</x-text>
            <x-flex horizontal end space="md">
              <x-button @click=${() => resolve()}> <x-text> ${buttonText} </x-text> </x-button>
            </x-flex>
          </x-flex>
        `);
      }
    });
  }
};
ElementsDialog = __decorateClass([
  customElement("x-dialog")
], ElementsDialog);
export {
  ElementsDialog
};
